import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Flame } from "@phosphor-icons/react";
import DailyForge from "@/pages/DailyForge";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

function FullScreenLoader() {
  return (
    <div className="min-h-screen bg-stone-950 flex flex-col items-center justify-center gap-4">
      <Flame size={40} weight="fill" className="text-orange-700 animate-pulse" />
      <p className="font-mono-ui text-xs uppercase tracking-[0.25em] text-stone-500">Loading</p>
    </div>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function LoginRoute() {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function AppRouter() {
  const location = useLocation();
  // Handle Google OAuth return synchronously (before protected routes run).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<LoginRoute />} />
      <Route
        path="/"
        element={
          <Protected>
            <DailyForge />
          </Protected>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
